import React, { useState } from 'react';
import moment, { Duration } from 'moment';
import Countdown from 'antd/lib/statistic/Countdown';
import { Statistic, Tag, Typography } from 'antd';
const { Text } = Typography;
import './CountdownHumanized.scss';
import { useInterval } from 'client/core/hooks/useInterval';
import { useTranslation } from 'react-i18next';
import { CountdownLabeledElement } from './CountdownLabeledElement';

export interface CountdownHumanizedProps {
  expireDate: null | undefined | Date;
}

const ALERT_MINUTES = 60 * 12; // visualizzazione countdown red
const WARN_HOURS = 48; // visualizzazione contudown arancio
const START_COUNTDOWN_DAYS = 60; // Visualizzazione countdown blu
//ATTENZIONE Visualizzazione testo: 'Più di due mesi'

/**
 * Mostra il countdown alla scadenza della presentazione di una domanda.
 */
export function CountdownHumanized(props: CountdownHumanizedProps) {
  const [dateNow, setDateNow] = useState(moment().tz('Europe/Rome'));
  useInterval(() => {
    setDateNow(moment().tz('Europe/Rome'));
  }, 1000);
  const { t } = useTranslation();

  if (!props.expireDate) return null;

  // definiamo il periodo di durata
  const date = moment(props.expireDate).tz('Europe/Rome');
  const duration = moment.duration(date.diff(dateNow));

  // se la durata non è valida non mostriamo l'elemento
  if (!duration.isValid()) return null;
  // se la durata è minore di un secondo non mostriamo l'elemento
  if (duration.asSeconds() < 0) return null;
  // if (date.diff(dateNow, 'seconds') < 0) return null;

  const diffDays = duration.asDays();

  const durationText = (duration: Duration): string => {
    if (duration.asYears() >= 1)
      return t('countdown-humanized.more-years', 'Più di un anno');
    if (diffDays > START_COUNTDOWN_DAYS)
      return t('countdown-humanized.more-months', 'Più di due mesi');
    return `${duration.days()} ${t('countdown-humanized.days', 'giorni')}`;
  };

  const tagColor =
    duration.asHours() > WARN_HOURS
      ? 'blue'
      : duration.asMinutes() > ALERT_MINUTES
      ? 'warning'
      : 'error';

  return (
    <div className="countdown-humanized">
      <Text type="secondary">
        {t('countdown-humanized.label', 'Tempo rimanente')}:{' '}
      </Text>

      {diffDays > START_COUNTDOWN_DAYS ? (
        <Tag className="countdown-tag">
          <Statistic value={durationText(duration)} />
        </Tag>
      ) : (
        <Tag color={tagColor}>
          <Countdown value={date.format()} format="DD : HH : mm : ss" />
          <div className="countdown-label-strip">
            <div className="label">gg/dd</div>
            <div className="label">hh</div>
            <div className="label">mm</div>
            <div className="label">ss</div>
          </div>
        </Tag>
      )}
    </div>
  );
}

// Countdovn come testo
// <Tag className="countdown-tag">
//   <Countdown
//     value={date.format()}
//     format="D [giorni], H [ore] m [minuti e] s [secondi]"
//   />
// </Tag>
